import { s as r, i as e, b as n } from "./caml-aa4fccd9.mjs";

var for_in = function(r, e) {
  for (var n in r) {
    e(n);
  }
};

function compare(t, a) {
  if (t === a) {
    return 0;
  }
  var i = typeof t;
  var u = typeof a;
  switch (i) {
   case "boolean":
    if ("boolean" === u) {
      return n(t, a);
    }
    break;

   case "function":
    if ("function" === u) {
      throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "compare: functional value",
        Error: new Error
      };
    }
    break;

   case "number":
    if ("number" === u) {
      return e(t, a);
    }
    break;

   case "string":
    if ("string" === u) {
      return r(t, a);
    } else {
      return 1;
    }

   case "undefined":
    return -1;
  }
  switch (u) {
   case "string":
    return -1;

   case "undefined":
    return 1;

   default:
    if ("boolean" === i) {
      return 1;
    }
    if ("boolean" === u) {
      return -1;
    }
    if ("function" === i) {
      return 1;
    }
    if ("function" === u) {
      return -1;
    }
    if ("number" === i) {
      if (null === a || void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
        return 1;
      } else {
        return -1;
      }
    }
    if ("number" === u) {
      if (null === t || void 0 !== t.BS_PRIVATE_NESTED_SOME_NONE) {
        return -1;
      } else {
        return 1;
      }
    }
    if (null === t) {
      if (void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
        return 1;
      } else {
        return -1;
      }
    }
    if (null === a) {
      if (void 0 !== t.BS_PRIVATE_NESTED_SOME_NONE) {
        return -1;
      } else {
        return 1;
      }
    }
    if (void 0 !== t.BS_PRIVATE_NESTED_SOME_NONE) {
      if (void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
        return aux_obj_compare(t, a);
      } else {
        return -1;
      }
    }
    var o = 0 | t.TAG;
    var f = 0 | a.TAG;
    if (248 === o) {
      return e(t[1], a[1]);
    }
    if (251 === o) {
      throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "equal: abstract value",
        Error: new Error
      };
    }
    if (o !== f) {
      if (o < f) {
        return -1;
      } else {
        return 1;
      }
    }
    var l = 0 | t.length;
    var s = 0 | a.length;
    if (l === s) {
      if (Array.isArray(t)) {
        var c = 0;
        while (1) {
          var v = c;
          if (v === l) {
            return 0;
          }
          var E = compare(t[v], a[v]);
          if (0 !== E) {
            return E;
          }
          c = v + 1 | 0;
        }
      } else if (t instanceof Date && a instanceof Date) {
        return t - a;
      } else {
        return aux_obj_compare(t, a);
      }
    } else if (l < s) {
      var _ = 0;
      while (1) {
        var d = _;
        if (d === l) {
          return -1;
        }
        var p = compare(t[d], a[d]);
        if (0 !== p) {
          return p;
        }
        _ = d + 1 | 0;
      }
    } else {
      var m = 0;
      while (1) {
        var b = m;
        if (b === s) {
          return 1;
        }
        var N = compare(t[b], a[b]);
        if (0 !== N) {
          return N;
        }
        m = b + 1 | 0;
      }
    }
  }
}

function aux_obj_compare(e, n) {
  var t = {
    contents: void 0
  };
  var a = {
    contents: void 0
  };
  var do_key = function(r, e) {
    var n = r[2];
    var t = r[1];
    if (Object.prototype.hasOwnProperty.call(t, e) && !(compare(r[0][e], t[e]) > 0)) {
      return;
    }
    var a = n.contents;
    if (void 0 !== a && e >= a) {
      return;
    } else {
      n.contents = e;
      return;
    }
  };
  var i = [ e, n, a ];
  var u = [ n, e, t ];
  for_in(e, (function(r) {
    return do_key(i, r);
  }));
  for_in(n, (function(r) {
    return do_key(u, r);
  }));
  var o = t.contents;
  var f = a.contents;
  if (void 0 !== o) {
    if (void 0 !== f) {
      return r(o, f);
    } else {
      return -1;
    }
  } else if (void 0 !== f) {
    return 1;
  } else {
    return 0;
  }
}

function equal(r, e) {
  if (r === e) {
    return !0;
  }
  var n = typeof r;
  if ("string" === n || "number" === n || "boolean" === n || "undefined" === n || null === r) {
    return !1;
  }
  var t = typeof e;
  if ("function" === n || "function" === t) {
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "equal: functional value",
      Error: new Error
    };
  }
  if ("number" === t || "undefined" === t || null === e) {
    return !1;
  }
  var a = 0 | r.TAG;
  var i = 0 | e.TAG;
  if (248 === a) {
    return r[1] === e[1];
  }
  if (251 === a) {
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "equal: abstract value",
      Error: new Error
    };
  }
  if (a !== i) {
    return !1;
  }
  var u = 0 | r.length;
  if (u === (0 | e.length)) {
    if (Array.isArray(r)) {
      var o = 0;
      while (1) {
        var f = o;
        if (f === u) {
          return !0;
        }
        if (!equal(r[f], e[f])) {
          return !1;
        }
        o = f + 1 | 0;
      }
    } else if (r instanceof Date && e instanceof Date) {
      return !(r > e || r < e);
    } else {
      var l = {
        contents: !0
      };
      for_in(r, (function(r) {
        if (!Object.prototype.hasOwnProperty.call(e, r)) {
          l.contents = !1;
          return;
        }
      }));
      if (l.contents) {
        for_in(e, (function(n) {
          if (!Object.prototype.hasOwnProperty.call(r, n) || !equal(e[n], r[n])) {
            l.contents = !1;
            return;
          }
        }));
      }
      return l.contents;
    }
  } else {
    return !1;
  }
}

function lessthan(r, e) {
  return compare(r, e) < 0;
}

export { equal as e, lessthan as l };
